import React from 'react';
import { useTranslation } from 'react-i18next';

const OptionStateSelector = ({ options, selectedOption, onSelect, btnClassName = '' }) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col">
      <span className="w-full break-words text-footnote1 capitalize leading-[16px] text-N700 text-text-secondary">
        {t('js.features.shared.option_state_selector.unit') as string}
      </span>
      <div className="flex space-x-3">
        {options.map((option) => {
          return (
            <button
              key={option.value}
              className={`rounded-full px-4 py-2 ${btnClassName} ${
                selectedOption && selectedOption === option.value
                  ? 'bg-black text-white'
                  : 'border-[1px] border-black'
              }`}
              onClick={() => onSelect(option.value)}
            >
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export { OptionStateSelector };
